import { 
	CheckBoxList, 
	ExpandFullPagePanel,  
	MessageBox, 
} from 'component-library';
import { RFSearchPanel } from '../RFSearchPanel/RFSearchPanel.js';
import { pluralConcepts } from '../../functions/pluralConcepts/pluralConcepts.js';
const { useState } = wp.element;
import { useDidUpdateEffect } from 'hooks-library';

/*this component outputs relationship creator form
Props:

*/
export function ConceptRelationshipCreatorForm(props) {
	
	let f = ConceptRelationshipCreatorFormNotHidden(props);

	return <ExpandFullPagePanel
		open = {(props.currentSelections == undefined || props.currentSelections.length == 0) ? 'Add' : 'Edit'}
		close = 'Close Editor'
		notHiddenPre = {f[0]}
		{...props.expandFullPagePanelAttributes}
	>
	{f[1]}
	</ExpandFullPagePanel>;
}

export function ConceptPresentingList(props) {
	
	if( props.data == undefined || ( props.data == null || props.data.length == 0 ) ) {
		 return null;
	}
	
	let checks = props.current?.reduce((carry, item) => {
			carry.push(item['id_'+props.concept]);
			return carry; 
		}, []),
		processResults = props.processResults ?? function (d, ignore){return d;},
		choices = props.data.reduce((carry, item) => {
			let defaultSetting = {	
				inputAttributes: {
					value: JSON.stringify(item),
					name: props.concept+'['+ item['id_'+props.concept] +']',
					onClick: props.onClick,
					checked: checks?.includes(item['id_'+props.concept]) ? 'checked' : false,
					... props.inputAttributes
				},
				label: item[props.concept],
			};

			carry.push( processResults(defaultSetting, item)); 
			return carry;
		}, []);
	return <CheckBoxList
		id={props.concept} 
		current={props.current} 
		choices={choices} 
	/>
}

export function ConceptRelationshipCreatorFormNotHidden(props) {
	
	//create the basic state for the form.
	const [currentSelections, setCurrentSelections] = useState(props?.currentSelections),
		[message, setMessage] = useState({message:'', messageType:null}),
		[trigger, setTrigger] = useState(false);
		
	//change the current selections
	function updateCurrentSelections(event) {
		let { name, value } = event.target,
			copyOfCurrentSelections = currentSelections !== undefined ? [...currentSelections] : [];
		
		value = JSON.parse(value);

		//for removing the current selection
		if ( event.target.type == "checkbox" && !event.target.checked ) {
			let newCurrentSelections = copyOfCurrentSelections.filter(e => e['id_'+props.concept] !== value['id_'+props.concept] );
				setCurrentSelections(newCurrentSelections);
			return;
		}

		//otherwise add a new selection
		copyOfCurrentSelections.push(value);
		setCurrentSelections(copyOfCurrentSelections);
	}

	useDidUpdateEffect(() => {
		if (props.onCurrentSelectionsChange !== undefined) {
			props.onCurrentSelectionsChange(currentSelections);
		}
	 }, [currentSelections]);

	return [
		<>
		{ currentSelections?.length > 0 ? <h3>Currently Selected</h3> : <p>None selected</p> }
			<ConceptPresentingList
				concept={props.concept} 
				current={currentSelections} 
				data={currentSelections}
				onClick={updateCurrentSelections}
				inputAttributes={props.presentingInputAttributes}
			/>
		</>,
		<>
			<p>Search for {pluralConcepts(props.concept)} to add.</p>
			<MessageBox messageType={message.messageType} id={'mainMessage'}  tabindex="-1">{message.message}</MessageBox>
			<RFSearchPanel
				concept={props.concept}
				setTrigger={setTrigger}
				setMessage={setMessage}
				trigger={trigger}
			>
				<ConceptPresentingList
					concept={props.concept} 
					current={currentSelections} 
					data-results={true}
					processResults={props.processResults}
					onClick={updateCurrentSelections}
				/>
			</RFSearchPanel>
		</>
	];
}